import { Env } from '@/common/types';
import { Breadcrumbs, BreadcrumbsProps } from '@/components/Breadcrumbs';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import React from 'react';
import styles from './Footer.module.scss';
import { GeneralSection } from './GeneralSection';
import { MarketingSection, MarketingSectionProps } from './MarketingSection';

export interface FooterProps {
  env: Env;
  marketingSectionData?: MarketingSectionProps;
  breadcrumbs?: BreadcrumbsProps;
}

export const Footer: React.FC<FooterProps> = ({ env, marketingSectionData, breadcrumbs }) => {
  return (
    // Don't error out complete page if footer fails
    <ErrorBoundary env={env} caller="Footer" fallback={<></>}>
      <footer className={styles.footer_container}>
        <div className={styles.footer_content}>
          {breadcrumbs && (
            <div className={styles.breadcrumbs_container}>
              <Breadcrumbs {...breadcrumbs} />
              <hr className={styles.divider} />
            </div>
          )}
          {marketingSectionData && (
            <>
              <MarketingSection {...marketingSectionData} />
              <hr className={styles.divider} />
            </>
          )}
          <GeneralSection env={env} />
        </div>
      </footer>
    </ErrorBoundary>
  );
};
